import React from 'react';

//CORE COMPONENTS
import { IntegratorRoot } from '../../../components-core/packages/components-core/dist/integrator-root';
import { 
    ThemeProvider, 
    styled 
} from '../../../components-core/packages/components-core/dist/theme-provider';
import { Image } from '../../../components-core/packages/components-core/dist/image';
import { Text, TextAppearance, TextColor, TextAlignment } from '../../../components-core/packages/components-core/dist/text';

//BUTTON
import { Button, ButtonAppearance} from '../../../components-core/packages/components-core/dist/button';
import { Link } from '../../../components-core/packages/components-core/dist/link';

//LAYOUT
import { 
    Container, 
    ContainerWrap, 
    ContainerPadding,
    ContainerVerticalAlignment,
    ContainerHorizontalAlignment,
    ContainerGutter,
} from '../../../components-core/packages/components-core/dist/container';
import {  Layout, LayoutConfigurations } from '../../../components-core/packages/components-core/dist/layout';
import { BreakpointWrapper } from '../../../components-core/packages/components-core/dist/breakpoint-wrapper';
import { Breakpoints } from '../../../components-core/packages/components-core/dist/helpers';
import { LayerWrapper } from '../../../components-core/packages/components-core/dist/layer-wrapper';
import { InteractionLayer, InteractionLayerSize } from '../../../components-core/packages/components-core/dist/interaction-layer';
import { TextInput, TextInputAppearance } from '../../../components-core/packages/components-core/dist/text-input';
//ICONS
import { Close } from '../../../components-core/packages/icons-core/dist/Close';
import { Phone } from '../../../components-core/packages/icons-core/dist/Phone';
import { Mail } from '../../../components-core/packages/icons-core/dist/Mail';
import { Magnifier } from '../../../components-core/packages/icons-core/dist/Magnifier'


const grid001 = ContainerPadding.grid001;
const grid002 = ContainerPadding.grid002;
const grid003 = ContainerPadding.grid003;
const grid004 = ContainerPadding.grid004;

const generalPadding = {
    [Breakpoints.default]: grid002,
    [Breakpoints.b960]: grid003,
    [Breakpoints.b1280]: grid004,
}

const singleColumnPadding = {
    [Breakpoints.default]: grid001,
    [Breakpoints.b560]: grid001,
}

const CustomContainer = styled.div`
    height: 100%;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
`;


class DealerSheet extends React.Component {

    constructor() {
        super();
        this.state = {
        }
    }

    renderTitle() {

        
        return (
            <Container wrap={ContainerWrap.always}>
                <Text appearance={TextAppearance.headline0300} >
                    Yetkili satıcı ve servis ağı
                </Text>
                <TextInput 
        appearance={TextInputAppearance.Default}
        label={'Yetkili servis veya il giriniz'}
        placeholder={'Yetkili servis veya il giriniz'}
    />

                
            </Container>
            

        )
    }

    renderLeftContainer(){

        const paddings = {
            left: {
                [Breakpoints.default]: grid002,
                [Breakpoints.b960]: grid002,
                [Breakpoints.b1280]: grid004
            },
            right: {
                [Breakpoints.default]: grid002,
                [Breakpoints.b960]: grid002,
                [Breakpoints.b1280]: grid001
            },
        }

        const alignments = {
            [Breakpoints.default]: ContainerHorizontalAlignment.center,
            [Breakpoints.b960]: ContainerHorizontalAlignment.flexStart,
            [Breakpoints.b1280]: ContainerHorizontalAlignment.center,
        }

        const textAlignments = {
            [Breakpoints.default]: TextAlignment.center,
            [Breakpoints.b960]: TextAlignment.left,
            [Breakpoints.b1280]: TextAlignment.center,
        }

        return(
            <CustomContainer>
            <Container                 
            gutter={ContainerGutter.dynamic0100}
            padding={paddings} 
            horizontalAlign={alignments}
        >
            {this.renderTitle()}

            <Container 
                wrap={ContainerWrap.always} 
                horizontalAlign={alignments}
                gutter={ContainerGutter.dynamic0100}
            >
                <Container horizontalAlign={alignments}>
                </Container>
                <div style={{backgroundColor:'#000000'}}></div>
            </Container>
        </Container>
    </CustomContainer>
        )
        
    }

    renderRightContainer(){
        const padding = { 
            right: generalPadding, 
            left: singleColumnPadding,
        }

        return (
            <Container 
                padding={padding}
                horizontalAlign={ContainerHorizontalAlignment.center}
            >
            <Text bold>Önerilen Şehirler</Text>
            
            </Container>
        )
    }


    render() {
        return(
            <ThemeProvider>
                <Container padding={{ top: ContainerPadding.dynamic0250, bottom: ContainerPadding.dynamic0250 }}>
                    <Layout appearance={LayoutConfigurations.half} rowGap={ContainerGutter.dynamic0250} >
                        {this.renderLeftContainer()}
                        {this.renderRightContainer()}
                    </Layout>
                </Container>
        </ThemeProvider>
        )
    }



}

export default DealerSheet;